// extracted by mini-css-extract-plugin
module.exports = {"info-card":"InfoCard_info-card__3rbRX"};